import { css } from "lit";

export const menuStyles = css `
    md-menu-container-color,
    md-menu-container-shape,
    md-menu-item-container-color,
    md-menu-item-selected-container-color
`